import _ from 'lodash';
import { affiliate } from '../../../redux/modules/session/actions';
import { AffiliateDetailsAttributes } from '../../types/AffiliateDetails';

export const GetAllAffiliatesIds = (affiliateDetails: any) => {

    const groupAffiliates = affiliateDetails?.GroupData?.length > 0 ? affiliateDetails.GroupData : [],
        isGroupAffiliate = groupAffiliates.length > 0;

    const allAffiliateIds = groupAffiliates.map((affiliateData) => (
        affiliateData.affNumbers
    ));

    return isGroupAffiliate ? ([affiliateDetails?.affiliate?.affiliate_Number, ...allAffiliateIds]) : ([affiliateDetails?.affiliate?.affiliate_Number]);
};

export const GetCurrentAffiliateIds = (affiliateNumbers: Array<string>, selectedAffiliateValue: string): Array<string> => {
    if (!selectedAffiliateValue) {
        return [affiliate()];
    }
    if (selectedAffiliateValue !== 'all' && selectedAffiliateValue?.length > 0) {
        return [selectedAffiliateValue];
    } else {
        return affiliateNumbers;
    }
};

const getAllAffiliatesData = (affiliateDetails, groupAffiliates, translate, module = 'commissions') => {
    const allAffiliatesData = groupAffiliates.map((affiliateData) => (
        {
            affiliateNumber: affiliateData.affNumbers,
            affiliateName: affiliateData.name,
            subAffiliate: affiliateData.subAffiliate
        }
    ));

    return [
        {
            affiliateNumber: affiliateDetails.affiliate.affiliate_Number,
            affiliateName: affiliateDetails.affiliate.company_name,
            subAffiliate: []
        },
        ...((module === 'referrals' &&
            [{
                affiliateNumber: 'all',
                affiliateName: translate('referrals.group.affiliate.label'),
                subAffiliate: []
            }]) || [])
        ,
        ...allAffiliatesData
    ];
};

export const GetAllAffiliateDetails = (affiliateDetails: AffiliateDetailsAttributes, translate: Function, module = 'commissions') => {
    const groupAffiliates = affiliateDetails?.GroupData?.length > 0 ? affiliateDetails.GroupData : [],
        isGroupAffiliate = groupAffiliates.length > 0;

    const allAffiliatesData = isGroupAffiliate ? getAllAffiliatesData(affiliateDetails, groupAffiliates, translate, module) : [];

    const allAffiliatesNumbers = allAffiliatesData.reduce(function (affiliateIds, affiliateData) {
        if (affiliateData.affiliateNumber !== 'all') { // this serves as our `filter`
            affiliateIds.push(affiliateData.affiliateNumber);

            const subAffiliateIds: Array<string> = affiliateData.subAffiliate.length > 0 ? _.map(affiliateData.subAffiliate, obj => _.get(obj, 'affNumbers')) : [];

            affiliateIds = [...affiliateIds, ...subAffiliateIds];
        }
        return affiliateIds;
    }, []);

    // Created new array to send base affiliate number to API on initial load
    let baseAffiliateNumberArray: Array<string> = [];
    baseAffiliateNumberArray.push(allAffiliatesNumbers?.[0] || affiliateDetails?.affiliate?.affiliate_Number)

    return {
        isGroupAffiliate,
        groupAffiliates,
        allAffiliatesData,
        allAffiliatesNumbers,
        baseAffiliateNumberArray
    }
}
